import React from 'react';
import { connect } from 'react-redux';
import { Theme } from './CommonTypes';

function SubtractButton({
  onClick,
  small = false,
  disabled = false,
  mobile = false,
  theme,
}: {
  onClick: () => void;
  small?: boolean;
  disabled?: boolean;
  mobile?: boolean;
  theme?: Theme;
}) {
  return (
    <button
      onClick={!disabled ? onClick : () => {}}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      aria-label={disabled ? 'Remove bag (disabled)' : 'Remove bag'}
      className={`${
        !disabled ? 'gr-cursor-pointer' : 'gr-cursor-default'
      } gr-flex subtract-btn gr-items-center gr-border-0 gr-bg-transparent gr-p-0`}
    >
      {small ? (
        <svg
          width={mobile ? '16' : '20'}
          height={mobile ? '16' : '20'}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8"
            cy="8"
            r="8"
            fill={
              disabled
                ? '#8D8D8D4D'
                : (theme?.bags?.subtractButtonColor ?? '#4CA7DE')
            }
          />
          <g clipPath="url(#clip0_0_1)">
            <path d="M5 7.5H11V8.5H5V7.5Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_0_1">
              <rect
                width="12"
                height="12"
                fill="white"
                transform="translate(2 2)"
              />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width={mobile ? '26' : '34'}
          height={mobile ? '24' : '32'}
          viewBox={'0 0 26 24'}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0"
            y="0"
            width="26"
            height="24"
            fill={
              disabled
                ? '#8D8D8D4D'
                : (theme?.bags?.addButtonColor ?? '#4CA7DE')
            }
            rx={theme?.bags?.addButtonRounding ?? 9}
            ry={theme?.bags?.addButtonRounding ?? 9}
          />
          <path
            d="M6.64869 10.556H18.3607V12.668H6.64869V10.556Z"
            fill="white"
          />
        </svg>
      )}
    </button>
  );
}

const mapStateToProps = (state: any) => ({
  theme: state.session.theme,
});

export default connect(mapStateToProps)(SubtractButton);
